
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getDepartmentList } from '@/api/company';
import { getWorkUser } from '@/api/users';
import { UserModule } from '@/store/modules/user';

@Component({
  name: 'GroupDialogStep2',
  components: {

  }
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  selectedDeptvisible!: Boolean;
  @Prop({
    type: Object,
    default: () => ({})
  })
  selectedDept!: any;

  private searchDept: any = {
    name: ''
  }
  private deptTableData: any = []
  private engTableData: any = []
  private selectedData:any = {}
  private selectedUserData:any={}
  private deptLoading = false;
  private engLoading = false;

  private page:number=1;
  private pageCount:number=1;
  created() {
    this.getDeptList();
  }
  private getDeptList() {
    this.deptLoading = true;
    let params: any = {
      page: this.page,
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      type: '9', // 部门类型 1报修部门 2服务部门 3审批部门 9所有部门 (必填)
      dept_type: 2 // 部门类型 1报修部门 2服务部门
    };
    if (this.searchDept.name) {
      params.name = this.searchDept.name;
    }
    getDepartmentList(params)
      .then((res) => {
        if (res.data) {
          this.pageCount = res.data.page_count;
        }
        if (this.page === 1) {
          this.deptTableData = res.data.list;
        } else {
          this.deptTableData = this.deptTableData.concat(res.data.list);
        }
        this.setDept(this.deptTableData);
        this.deptLoading = false;
      })
      .catch((err) => {
        this.deptLoading = false;
        let msg = err.msg;
      });
  }
  private setDept(list:any) {
    if (this.selectedDept && this.selectedDept.servicer_dept_id) {
      if (list && list.length > 0) {
        for (let item of list) {
          if (this.selectedDept.servicer_dept_id === item.dept_id) {
            this.selectedData = item;
            this.getWorkUser();
            return;
          }
        }
      }
    }
  }
  private setSelectEng(list:any) {
    if (this.selectedDept && this.selectedDept.engineer_user_id) {
      if (list && list.length > 0) {
        for (let item of list) {
          if (item.user && (this.selectedDept.engineer_user_id === item.user.user_id)) {
            this.selectedUserData = item;
          }
        }
      }
    }
  }
  private deptMore() {
    this.page = this.page + 1;
    this.getDeptList();
  }
  private engMore() {
    this.engPage = this.engPage + 1;
    this.getWorkUser();
  }
  private searchHandle() {
    this.page = 1;
    this.getDeptList();
  }
  // private clearHandle() {
  //   this.searchDept.name = '';
  //   this.getDeptList();
  // }
  private selectedDeptChange(val: any) {
    this.engPage = 1;
    this.selectedUserData = {};
    this.getWorkUser();
  }
  // 获取 工程师
  private engPage:number=1
  private engPageCount:number=1;
  private getWorkUser() {
    const params: any = {
      dept_id: this.selectedData.dept_id,
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      page: this.engPage,
      size: 10
    };

    getWorkUser(params)
      .then((res: any) => {
        if (res.data) {
          if (this.engPage === 1) {
            this.engTableData = res.data.list;
          } else {
            this.engTableData = this.engTableData.concat(res.data.list);
          }
          this.setSelectEng(this.engTableData);
          this.engPageCount = res.data.page_count;
        } else {
          if (this.engPage === 1) {
            this.engTableData = [];
          }
        }
      })
      .catch((err: any) => {
        if (this.engPage === 1) {
          this.engTableData = [];
        }
        let msg = err.msg;
      });
  }
  private selectedEngChange(val: any) {
    if (this.selectedUserData === val) {
      this.selectedUserData = {};
    } else {
      this.selectedUserData = val;
    }
  }
  private nextHandle() {
    // 返回给父级 数据
    if (!this.selectedData || !this.selectedData.dept_id) {
      this.showErrorMsg('请选择部门');
      return;
    }
    let data:any = {};
    data.servicer_dept_id = this.selectedData.dept_id;
    data.servicer_dept_name = this.selectedData.name;
    if (this.selectedUserData.user) {
      data.engineer_user_id = this.selectedUserData.user.user_id;
      data.engineer_user_name = this.selectedUserData.user.name;
    }

    this.$emit('selectedStepNext', data);
  }
  private close() {
    this.$emit('close', false);
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
